import { CSpinner } from "@coreui/react";

export default function Loading()
{
  return(
    <div>
      <CSpinner color='primary' />
    </div>
  );
}